import { useState, useEffect } from 'react';
import { SvgComponent } from 'components';
import ToolTip from 'components/ToolTip/ToolTip';
import { useTheme } from 'hooks';
import "./AnimatedIconButton.style.css";

export const AnimatedIconButton = ({
  onClick,
  style,
  style2,
  size,
  disabled = false,
  iconName = "Grabar",
  width = "24px",
  height = "24px",
  message,
  placement,
  isWhite = false,
  useVendorTheme = false,
  id = "",
  clicked = false
}) => {
  const { theme } = useTheme();
  const [svgClass, setSvgClass] = useState("animated-button");
  const [divClass, setDivClass] = useState("animated-div");
  
  useEffect(() => {
    if (clicked === false) {
      setSvgClass("animated-button");
      setDivClass("animated-div");
    } else {
      setSvgClass("animated-button-hover");
      setDivClass("animated-div-hover");
    }
  }, [clicked]);
  return (
    <div style={style2}>
      {message ? (
        <ToolTip message={message} placement={placement}>
          <button
            type="button"
            onClick={onClick}
            className={`bootstrapiso animated-button ${disabled && "disabled"}`}
            style={style}
            disabled={disabled}
          >
            <div
              className={divClass}
              style={{
                ...style,
                height: size,
                width: size,
                backgroundColor:
                  divClass == "animated-div-hover"
                    ? theme.color1
                    : isWhite
                      ? "white"
                      : "transparent",
                borderColor: theme.color1,
              }}
              onMouseEnter={() => {
                setSvgClass("animated-button-hover");
                setDivClass("animated-div-hover");
              }}
              onMouseLeave={() => {
                if (!clicked) {
                  setSvgClass("animated-button");
                  setDivClass("animated-div");
                }
              }}
            >
              <SvgComponent
                height={height}
                width={width}
                iconName={iconName}
                fill={theme.color1}
                className={svgClass}
                id={id}
              />
            </div>
          </button>
        </ToolTip>
      ) : (
        <button
          type="button"
          onClick={onClick}
          className={`bootstrapiso animated-button ${disabled && "disabled"}`}
          style={style}
          disabled={disabled}
        >
          <div
            className={divClass}
            style={{
              ...style,
              height: size,
              width: size,
              backgroundColor:
                divClass == "animated-div-hover"
                  ? theme.color1
                  : isWhite
                    ? "white"
                    : "transparent",
              borderColor: theme.color1,
            }}
            onMouseEnter={() => {
              setSvgClass("animated-button-hover");
              setDivClass("animated-div-hover");
            }}
            onMouseLeave={() => {
              if (!clicked) {
                setSvgClass("animated-button");
                setDivClass("animated-div");
              }
            }}
          >
            <SvgComponent
              height={height}
              width={width}
              iconName={iconName}
              fill={theme.color1}
              className={svgClass}
              id={id}
            />
          </div>
        </button>
      )}
    </div>
  );
};
